import { DataService } from "../data.service";
import { MedicalServiceSearchItem } from "../../model/medical-service-search-item";
import { Injectable } from "@angular/core";
import { AuthService } from "../auth.service";
import { filter, map } from "rxjs/operators";

@Injectable()
export class ExtraccionistaMedicalService {
  constructor(
    public dataService: DataService,
    private authService: AuthService
  ) {}

  private readonly getMedicalServiceSearchItemEndPoint: string =
    "/extraccionistaMedicalService/getMedicalServiceSearchItem/";

  async getMedicalAppointments(
    date: Date,
    viewAttended: boolean,
    viewInterned: boolean,
    practiceRegionId?: number,
    patientId?: number
  ): Promise<MedicalServiceSearchItem[]> {
    const physicianId = null;
    const sectorId = this.authService.getSectorId();

    const params = {
      date: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      ).toDateString(),
      viewAttended,
      viewInterned,
      physicianId,
      sectorId,
      practiceRegionId,
      patientId,
    };

    return await this.dataService
      .get<MedicalServiceSearchItem[]>(
        this.getMedicalServiceSearchItemEndPoint,
        params
      )
      .pipe(
        map((value) => {
          console.log(value);
          return value.filter((m) => m.Protocol !== '');
        })
      )
      .toPromise();
  }
}
